<template>
	<div class="content">


	</div>
</template>

<script>
	export default {
		components: {
		},
		created() {
			this.$store.state.authentication.loggedIn = false
			this.$store.state.authentication.authToken = null
			this.$router.push("/")
		},
		data() {
			return {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Logout.vue